import { render } from "./InputFile.vue?vue&type=template&id=44ef44fe&ts=true"
import script from "./InputFile.vue?vue&type=script&lang=ts"
export * from "./InputFile.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__